import makeSlice from '@web/slices/branch/sliceMaker'

import {initOrderSheetByAPI} from '../../actions'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(initOrderSheetByAPI.fulfilled, (state, {payload}) => {
            const {
                data: {branch, giveawayProducts},
            } = payload
            if (branch) {
                state.branchNamesByDeliveryGroupKey = branch.branchNamesByDeliveryGroupKey
                state.branchMarketType = branch.branchMarketType ?? undefined
            }
            state.giveawayProducts = giveawayProducts ?? undefined
        })
    },
})

export default slice.reducer
